import FadeIn from 'react-fade-in';

import ui from "./images/ui.jpg";

export const Download = () => {

    return (
        <FadeIn>
        <div className="buttons">

            <ul className="buttonul">
                <li className="buttonil">
                    <a href="../bin/interactive-volume-visualization-bin.zip">
                    <div className="download windows">
                        <i className="fa fa fa-windows fa-3x"></i>
                        <span className="df">Download Executable</span>
                        <span className="dfn">Windows x64</span>
                    </div>
                    </a>
                </li>
                <li className="buttonil">
                    <a href="../src/interactive-volume-visualization-src.zip">
                    <div className="download source">
                        <i className="fa fa fa-code fa-3x"></i>
                        <span className="df">Download Source</span>
                        <span className="dfn">DX12 / C++</span>
                    </div>
                    </a>
                </li>

                <li className="buttonil">
                    <a href="https://github.com/bruluk5w/Visualisation_2-Interactive_Volume_Visualisation" target="_blank"  rel="noreferrer">
                    <div className="download android">
                        <i className="fa fa fa-github fa-3x"></i>
                        <span className="df">Visit Project on</span>
                        <span className="dfn">Github</span>
                    </div>
                    </a>
                </li>


            </ul>



                <div className={"pagecontainer"} >
                    <div className={"uidesc"}>
                    <h1>User Guide</h1>
                    The Downloads only come with a simple Sphere "dataset" so you will need to download datasets from
                    elsewhere. Here are some datasets we tested but feel free to try others:
                    <br /><br />
                    <ul>
                        <li className="datasetsli"><a href="https://www.cg.tuwien.ac.at/research/publications/2005/dataset-stagbeetle/" target="_blank"  rel="noreferrer"> Stag beetle</a></li>
                        <li className="datasetsli"><a href="https://www.cg.tuwien.ac.at/research/publications/2006/dataset-present/" target="_blank"  rel="noreferrer"> Christmas Present</a></li>
                        <li className="datasetsli"><a href="https://drive.google.com/file/d/1mgyWqZNNFkSEcqo8Y-jmI66bK_OV82yk/view?usp=sharing"  target="_blank"  rel="noreferrer"> CT Head</a></li>
                    </ul>
                    <br />


                    You can open them using the <b>Menu Button File -> Open</b>. The controls are shown in the bottom right.
                    The information in the top bar shows resolution, frames per second and remaining slices to be computed
                    for the current view. You can also access the Transfer Functions, Light and General Settings.

                        <img className={"uiimage"} src={ui}/>

                    <br/><br/>The <b>Transfer Functions</b> are by far the most complex: They are shown in the bottom
                    plot, which can be adjusted by adding and dragging control points using the left mouse button and removing them
                        with the right mouse button.
                    The plot shows the preintegration/lookup tables according to the edited transfer functions, so lowering Opacity
                    on the left while keeping it high on the right should let you see inside a given volume while still seeing some
                    outside boundaries of the volume. It's recommended to use stark changes, i.e. going from bottom to top in a
                        more vertical line instead of gradually.
                        <br/>
                        You can change Particle & Medium Color as well as Refraction in the same
                    way along the dataset, coloring different parts of the volume with different colors and using Refraction
                    only where you want to see it. For Refractions it is again recommended to use spikes when adjusting the values,
                        as to only apply the refraction to very specific parts of the volume, see the fourth Image in the Gallery
                        for an example.
                        <br/>For more detailed edits it is recommended to adjust the width and height parameters as well as the control point size of the transfer function display.

                    <br/><br/>The <b>Light direction</b> always originates at the current viewing position. The light color should be self-explanatory
                        though since we support HDR it is recommended to raise the values beyond 255 to lighten up the scene more.
                        Something like (400, 400, 400) should give you enough scope to adjust the particle & medium color properly.

                    <br/><br/>The <b>General Settings</b> let you disable the Dataset boundaries or enable the Viewing Volume boundaries
                    as well as choosing the number of slices per voxel, more leading to better image quality and less to better performance.
                    You can also enable Free Camera Movement to rotate the first person view.

                    </div>

                    <h1>Compiling From Source</h1>
                    Compiling was tested using Visual Studio 2019 & the Windows 10 SDK 10.0.18362.0. Before building make sure that "Visualization2" is set as startup project in Visual Studio.
                    Compiling may fail the first time around due to a robocopy error, but simply trying to recompile it should fix the issue.

                    <br/><br/>When compiling from source it is possible to edit the Image resolution in MainShader.h line 62.

                    <br /><br/>See also our <a href="../doc/index.html">Documentation</a>
                    <br/>
                    <br/>
                </div>

        </div>
        </FadeIn>
    )
}
